export default class Setting {

    key = '';
    value = '';

    constructor() {
    }
}